interface PostHogLogClient {
  logger: {
    info(message: string, attributes?: Record<string, boolean | number | string>): void;
    warn(message: string, attributes?: Record<string, boolean | number | string>): void;
  };
}

export function createPostHogLogger(posthog: PostHogLogClient) {
  return {
    agentRunCompleted(toolCount: number) {
      posthog.logger.info("agent chat run completed", {
        component: "agent_chat",
        tool_count: toolCount,
      });
    },
    agentRunFailed() {
      posthog.logger.warn("agent chat run failed", {
        component: "agent_chat",
      });
    },
  };
}
